import { selectChild } from "./selectChild";
import { addChild } from "./addChild";
import { isLogged } from "../../customer";

export const childrenModal = function () {
	if (isLogged()) {
		return `<div id="sub-overlay" style="display: none">
	            ${selectChild()}
	            ${addChild()}
	        </div>`;
	} else {
		var loginUrl = $('[data-testid="signin"]').attr('href');
		return `<div id="sub-overlay" style="display: none">
	            <div id="sub-step1">
	                <div class="sub-order-box">
	                    <button type="button" class="sub-exit">
	                        <img src="/user/documents/upload/subimg/cross.svg" />
	                    </button>
	                    <h3>Vyberte dítě pro které předplatné chcete</h3>
	                    <p>Pro předplatné HomeBox je nutné mít vytvořený účet a být přihlášen.</p>
	                    <button type="button" onClick="window.location.href = '${loginUrl}'" class="subscription-button">Přihlásit se</button>
	                </div>
	            </div>
	        </div>`;
	}
}

var closeModal = function () {
	$('#sub-overlay').hide();
	$('#sub-step2').hide();
	$('#sub-step1').show();
}

$(document).on('click', '.sub-exit', function (e) {
	e.preventDefault();
	closeModal();
});

$(document).on('keyup',function (e) {
	if (e.key === 'Escape') {
		e.preventDefault();
		closeModal();
	}
})

$(document).on('click', '#sub-overlay', function () {
	closeModal();
})

$(document).on('click', '#sub-overlay form, #sub-overlay .sub-order-box', function (e) {
	e.stopImmediatePropagation()
});

